export type CaseStudyTag =
	| 'non-profit'
	| 'health-care'
	| 'education'
	| 'content-creation'
	| 'software';

export const tagsToTranslations: {
	[key in CaseStudyTag]: string;
} = {
	'non-profit': 'caseStudies.tag.nonProfit',
	'health-care': 'caseStudies.tag.healthCare',
	education: 'caseStudies.tag.education',
	'content-creation': 'caseStudies.tag.contentCreation',
	software: 'caseStudies.tag.software',
};

export const getTagTranslationKey = (tag: string) =>
	tagsToTranslations[tag as CaseStudyTag];

export const allTagLinks: {
	tag: string | null;
	translationKey: string;
}[] = [
	{
		tag: null,
		translationKey: 'caseStudies.tag.all',
	},
	...Object.entries(tagsToTranslations).map(([tag, translationKey]) => ({
		tag,
		translationKey,
	})),
];
